<template>
  <ContextButton
    v-for="link in entry.links"
    :key="link.id"
    @click="$emit('delete', link)"
  >
    {{ link.legal_text_paragraph_linked.paragraph }}
    {{ link.legal_text_paragraph_linked.legal_text.name }}
  </ContextButton>
  <button
    v-if="entry.links.length > 1"
    class="w-full rounded p-2 text-center font-bold transition hover:bg-red-600 hover:text-white"
    @click="$emit('delete', entry)"
  >
    {{ $t("legal_text.context.delete_all") }}
  </button>
</template>

<script lang="ts" setup>
import type { ILegalText } from "~/models/ILegalText";
import type { ILegalTextParagraph } from "~/models/ILegalTextParagraph";
import type { ILink, ILinkChain } from "~/models/IUserEntry";

defineEmits<{
  // only included, so we don't get a warning when the parent attaches an event listener
  close: [];
  delete: [ILink | ILinkChain];
}>();

defineProps<{
  entry: ILinkChain;
  legalText: ILegalText;
  legalTextParagraph: ILegalTextParagraph;
}>();
</script>
